import type { ProjectDetail } from "@/mocks/admin/projects";

type Props = {
  customer: ProjectDetail["customer"];
  onMessage?: () => void;
};

export default function CustomerCard({ customer, onMessage }: Props) {
  return (
    <div className="bg-white border border-ink-100 rounded-lg p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display text-base font-bold text-ink-900">Customer</h3>
        <div className="flex items-center gap-2">
          {onMessage && (
            <button
              onClick={onMessage}
              className="inline-flex items-center gap-1 text-xs font-bold text-white bg-ink-900 hover:bg-ink-800 px-2.5 py-1.5 rounded-md cursor-pointer whitespace-nowrap"
            >
              <i className="ri-send-plane-line"></i>
              Contact
            </button>
          )}
          <button className="text-xs font-semibold text-brand-600 hover:text-brand-700 cursor-pointer whitespace-nowrap">
            Profile
          </button>
        </div>
      </div>

      <div className="flex items-center gap-3 mb-4 pb-4 border-b border-ink-100">
        <div
          className={`w-12 h-12 rounded-full ${customer.avatarColor} text-white text-sm font-bold flex items-center justify-center`}
        >
          {customer.initials}
        </div>
        <div className="min-w-0">
          <div className="font-semibold text-ink-900 truncate">{customer.name}</div>
          <div className="text-[11px] text-ink-500">
            Customer since {customer.customerSince} · {customer.completedMoves} prior moves
          </div>
        </div>
      </div>

      <ul className="space-y-2.5 text-sm">
        <li className="flex items-center gap-2.5">
          <span className="w-7 h-7 flex items-center justify-center rounded-md bg-cream-100 text-ink-500">
            <i className="ri-mail-line text-sm"></i>
          </span>
          <a
            href={`mailto:${customer.email}`}
            className="text-ink-700 hover:text-brand-700 truncate cursor-pointer"
          >
            {customer.email}
          </a>
        </li>
        <li className="flex items-center gap-2.5">
          <span className="w-7 h-7 flex items-center justify-center rounded-md bg-cream-100 text-ink-500">
            <i className="ri-phone-line text-sm"></i>
          </span>
          <a
            href={`tel:${customer.phone}`}
            className="text-ink-700 hover:text-brand-700 cursor-pointer"
          >
            {customer.phone}
          </a>
          <span className="text-[10px] text-ink-400 ml-1">primary</span>
        </li>
        <li className="flex items-center gap-2.5">
          <span className="w-7 h-7 flex items-center justify-center rounded-md bg-cream-100 text-ink-500">
            <i className="ri-phone-line text-sm"></i>
          </span>
          <a
            href={`tel:${customer.altPhone}`}
            className="text-ink-700 hover:text-brand-700 cursor-pointer"
          >
            {customer.altPhone}
          </a>
          <span className="text-[10px] text-ink-400 ml-1">alt</span>
        </li>
        <li className="flex items-center gap-2.5">
          <span className="w-7 h-7 flex items-center justify-center rounded-md bg-cream-100 text-ink-500">
            <i className="ri-megaphone-line text-sm"></i>
          </span>
          <span className="text-ink-700">Referred by {customer.referredBy}</span>
        </li>
      </ul>
    </div>
  );
}